import initWeatherWidget from '../common/scripts/weather_widget'

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initWeatherWidget()
  })
} else {
  initWeatherWidget()
}
